<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        费控系统
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 坐班指纹打卡 -->
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">事前费用申请操作流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第一步：登录OA系统（oa.xdf.cn，账户密码与个人企业邮箱同步），点击【费用审批】。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第二步：点击【事前费用申请】-【我新建的费用申请】-【新建】，按照实际发生的费用类型选择【费用类别】建立表单。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第三步：系统将自动默认当前用户为实际申请人，同时带出【费用所属期间】、【预算部门】等信息。如填表人非实际申请人，需重新【选择】实际申请人。选择并完善标星处信息。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">事前费用申请操作流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第四步：如需关联使用其他事前申请、专项预算，可点击【下拉箭头】，选择对应专项。如选择多个专项，则后续【业务明细】、【财务明细】则需要从该多个专项中进行选择。如果没有选择任何专项，【业务明细】和【财务明细】中则选不了任何专项。关联使用其他事前申请、专项预算时需实际申请人有该业务查看权限，否则选择不到。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第五步：选择【业务明细】，填写并完善标星处信息，如该笔款项涉及几个部门分摊，可点击【+】进行拆解。确认无误后，点击【确认业务明细填写完毕】。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">事前费用申请操作流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第六步：填写【财务明细】，系统会自动根据费用类型对应的会计科目、会计科目对应的预算科目，计算该业务明细是否超【费用申请明细预算】、【超机构预算】、【超专项预算】，该数据可供申请人员参考。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第七步：根据实际情况如需一并借款，可填写【借款金额】，选择【借款类型】为备用金，完善填写【收款人明细】，确认无误后点击右上角【提交】。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">事前费用申请操作流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第八步：点击【事前费用申请】-【所有费用申请】，可在业务列表中查看单据状态、当前处理人等信息。</p>
                    <img src="../../assets/4.jpeg" alt="" class="QRcode">
                    <sup id="box_text_content">长按观看视频教程</sup>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            console.log(name)
            if(name == 'ui'){
                this.$router.push({name:"IssueManpower1"})
            } else {
                this.$router.push({name:'Finance'})
            }
        },
        fn() {
            var code = this.$route.params.code;
            if (code == 11) {
                this.fingerprintShow = true;
            } else if (code == 12) {
                this.flowShow = true;
            } else if (code == 79) {
                this.agreementShow = true;
            }
        },
        getOnPage(){
            this.$router.push({name: 'Search', params:{code:"111"}})
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30% !important;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#textTitleContent {
    color: #888787;
    font-size: 14px;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Finance/finance2.vue